import React from 'react'
import PropTypes from 'prop-types'

/**
 *
 * LicenseTypeBadge
 *
 * - Says whether a license was paid for or came out of the exhibitor's free allotment
 * - Sits next to LicenseStatusBadge, which reports refund/cancel state instead. The two
 *   answer different questions: a paid license can be refunded, a free one never can
 */
const LicenseTypeBadge = ({ isFreeLicense }) => (
  <div
    className={`rounded-full px-2.5 py-0.5 ${
      isFreeLicense ? 'bg-status-blue text-status-darkBlue' : 'bg-status-purple text-role-user'
    }`}
  >
    <span className="whitespace-nowrap text-xs font-bold">{isFreeLicense ? 'Free' : 'Paid'}</span>
  </div>
)

LicenseTypeBadge.defaultProps = {
  isFreeLicense: false,
}

LicenseTypeBadge.propTypes = {
  isFreeLicense: PropTypes.bool,
}

export default LicenseTypeBadge
